import get from 'lodash/get';
import {
  selectSubscriptionProviderName,
  selectSubscriptionStatus,
} from '../../selectors/me';
import subscribedThroughWeb from './subscribedThroughWeb';
import {
  currentSubscriptionStatus,
  premiumSubscriptionStatus,
} from './subscriptionStatus';

const { expired, canceled } = currentSubscriptionStatus;

export default ({ me, subscription }) => {
  const status = get(subscription, 'current.status');
  const providerName = selectSubscriptionProviderName({ me });
  const premiumStatus = selectSubscriptionStatus({ me });

  return (
    subscribedThroughWeb(providerName) &&
    ([expired, canceled].includes(status) ||
      premiumStatus === premiumSubscriptionStatus.expired)
  );
};
